import { ArrayAdapter, EntitiesAdapter, EntityState } from '@commons/util/utilities/store/entity';

import { ChannelType, toString } from '@contact/upgrade';

import { BasketCategoryType, Sort } from './models/basket';

export type BasketId = string | number;

export interface BasketModel {
  // id of basket request
  readonly id: BasketId;
  // is selected request
  readonly selected: boolean;
  // is error request
  readonly error: boolean;
  // draftUuid if present
  readonly draftUuid?: string;
}

export interface BasketColumnModel {
  // column name
  readonly label: string;
  // if sort key is present well column could be sort
  readonly sortKey?: string;
}

export interface BasketCategoryModel<T extends BasketColumnModel = BasketColumnModel> {
  // type of category
  readonly category: BasketCategoryType;
  // last label selected
  readonly lastLabelSelected: string;
  // columns to display
  readonly columns: T[];
  // sort type for requests result
  readonly sort: Sort;
}

export interface BasketLabelModel<T extends BasketModel = BasketModel> {
  // type of label
  readonly label: string;
  // label category
  readonly category: BasketCategoryType;
  // last loaded timestamp
  readonly timestamp: number;
  // number of requests global without filter
  readonly nbTotalRequests: number;
  // number of requests for current query
  readonly nbRequests: number;
  // list of requests loaded
  readonly requests: EntityState<T>;
  // requests in error
  readonly requestsInError: BasketId[];
  // requests in error
  readonly requestsSelected: BasketId[];
  // current page to display
  readonly currentPage: number;
  // uniq id to sort filter
  readonly order?: number;
  // should show paginator component
  readonly showPagination: boolean;
}

export interface BasketChannelModel<T extends BasketLabelModel = BasketLabelModel, C extends BasketCategoryModel = BasketCategoryModel> {
  // channel for this given basket
  readonly channel: ChannelType;
  // if basket is currently loading
  readonly loading: boolean;
  // size to display request by page
  readonly pageSize: number;
  // current category selected
  readonly categorySelected: BasketCategoryType;
  // list of category available
  readonly categories: EntityState<C>;
  // type of label selected
  readonly labelSelected: string;
  // label model list
  readonly labels: EntityState<T>;
}

export interface BasketStoreModel<T extends BasketChannelModel = BasketChannelModel> {
  // current channel selected
  readonly channelSelected: ChannelType;
  // channels available
  readonly channels: EntityState<T>;
  // is basket open
  readonly open: boolean;
}

export const ADAPTER_BASKET_REQUESTS = new EntitiesAdapter<BasketModel>(s => toString(s.id) + (s.draftUuid ? `|${s.draftUuid}` : ''));
export const ADAPTER_BASKET_REQUEST_IDS = new ArrayAdapter<BasketId>(id => toString(id));
export const ADAPTER_BASKET_LABEL = new EntitiesAdapter<BasketLabelModel>(s => s.label);
export const ADAPTER_BASKET_CATEGORY = new EntitiesAdapter<BasketCategoryModel>(s => s.category);
export const ADAPTER_BASKET_CHANNELS = new EntitiesAdapter<BasketChannelModel>(s => s.channel);

export const INITIAL_STATE: BasketStoreModel = {
  channelSelected: ChannelType.MAIL,
  channels: ADAPTER_BASKET_CHANNELS.getInitialState(),
  open: false,
};
